import React from 'react';
import { C } from './styles/theme';
import { resolveTeam } from './doublesHelper';

const S = {
  wrap: { background: C.white, borderRadius: 12, overflow: 'hidden', border: `1px solid ${C.g200}` },
  header: { display: 'flex', padding: '12px 20px', background: C.navy, color: C.lime, fontWeight: 700, fontSize: 11, letterSpacing: 1, fontFamily: "'Outfit', sans-serif" },
  row: { display: 'flex', padding: '12px 20px', borderBottom: `1px solid ${C.g100}`, alignItems: 'center', fontSize: 13 },
};

export default function RoundRobinTable({ standings, players }) {
  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <span style={{ flex: 0.4 }}>#</span>
        <span style={{ flex: 2.5 }}>PLAYER</span>
        <span style={{ flex: 0.6, textAlign: 'center' }}>P</span>
        <span style={{ flex: 0.6, textAlign: 'center' }}>W</span>
        <span style={{ flex: 0.6, textAlign: 'center' }}>L</span>
        <span style={{ flex: 0.8, textAlign: 'center' }}>SETS</span>
        <span style={{ flex: 0.6, textAlign: 'center' }}>PTS</span>
      </div>
      {standings.map((s, i) => {
        const p = resolveTeam(s.playerId, players);
        return (
          <div key={s.playerId} style={{ ...S.row, background: i === 0 ? 'rgba(0,32,91,0.03)' : i % 2 === 0 ? C.white : C.g50 }}>
            <span style={{ flex: 0.4, fontWeight: 700, color: i === 0 ? C.navy : C.g400 }}>{i + 1}</span>
            <span style={{ flex: 2.5, fontWeight: 500, color: C.navy }}>{p.name}</span>
            <span style={{ flex: 0.6, textAlign: 'center' }}>{s.played}</span>
            <span style={{ flex: 0.6, textAlign: 'center', color: C.green, fontWeight: 600 }}>{s.wins}</span>
            <span style={{ flex: 0.6, textAlign: 'center', color: C.red, fontWeight: 600 }}>{s.losses}</span>
            <span style={{ flex: 0.8, textAlign: 'center', fontFamily: "'Outfit', sans-serif" }}>{s.setsWon}–{s.setsLost}</span>
            <span style={{ flex: 0.6, textAlign: 'center', fontWeight: 800, color: C.navy, fontFamily: "'Outfit', sans-serif", fontSize: 15 }}>{s.points}</span>
          </div>
        );
      })}
    </div>
  );
}
